import * as React from 'react';
import {View} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import {useSelector} from 'react-redux';
import {themeSelector} from '../../../redux/selectors/runtime/theme';
import {VisImpStatus} from '../../models/visuallyImpairedSettings';
import {Props} from './model';

export const hexWithAlpha = (hexCode: string, alpha: number = 1): string => {
  const alphaFixed2: string = alpha.toFixed(2);
  return (
    hexCode +
    Math.round(+alphaFixed2 * 255)
      .toString(16)
      .substring(0, 2)
  );
};

export const GradientView = ({gradient, children, ...props}: Props) => {
  const {locations = undefined, angle = 0, colors = []} = gradient;
  const {visuallyImpaired} = useSelector(themeSelector());

  return visuallyImpaired === VisImpStatus.Active ? (
    <View {...props}>{children}</View>
  ) : (
    <LinearGradient colors={colors} angle={angle} locations={locations} useAngle {...props}>
      {children}
    </LinearGradient>
  );
};
